import React from 'react';

import { CareTeamCandidate } from '@vestahealthcare/common/models';

import { CollapsableSidebar, Colors } from 'styleguide-v2';

import { CandidateFieldsPanel } from '../../../components/CandidateFieldsPanel';

type Props = {
  open: boolean;
  candidate: CareTeamCandidate | null;
  onClose: () => void;
};

export const CareTeamCandidateInfoDrawer = ({
  open,
  candidate,
  onClose,
}: Props) => {
  return (
    <CollapsableSidebar
      open={open}
      onClose={onClose}
      title={
        candidate
          ? `${candidate.fullName} - Candidate Details`
          : 'Candidate Details'
      }
      size={600}
    >
      {candidate && (
        <div>
          {candidate.candidateFieldValues &&
          candidate.candidateFieldValues.length > 0 ? (
            <CandidateFieldsPanel candidate={candidate} />
          ) : (
            <div
              style={{
                color: Colors.darkGray,
                textAlign: 'center',
                padding: '20px',
              }}
            >
              No Additional Information found
            </div>
          )}
        </div>
      )}
    </CollapsableSidebar>
  );
};

export default CareTeamCandidateInfoDrawer;
